import {useEffect, useState} from "react"


const ValuerAmendPreviewContainer = (props) => {
    const { valuesIdentifiers, valuesOptions, text, field, currentValues } = props
    const [preview, setPreview] = useState("")

    const ConstructText = (values) => {
        let string = ""

        for (let i = 0; i < text.length; i++) {
            const _value = values[i]
            const optionsMap = valuesOptions[i]
            let value_string = "[SELECT]"

            if (_value && typeof _value === "object") {
                const selectedLabels = Object.entries(_value)
                    .filter(([_, v]) =>
                        v !== null &&
                        v !== 0 &&
                        v !== "0"
                    )
                    .map(([k]) => optionsMap[k])
                    .filter(Boolean)

                if (selectedLabels.length === 1) {
                    value_string = selectedLabels[0]
                } else if (selectedLabels.length > 1) {
                    value_string = selectedLabels.slice(0, -1).join(", ") + " and " + selectedLabels.at(-1)
                }
            } else if (_value) {
                value_string = _value
            }

            string += `${text[i]} ${value_string} `
        }

        return string.trim()
    }

    useEffect(() => {
        const valueList = valuesIdentifiers.map(id => currentValues?.[id] || {})
        const built = ConstructText(valueList)
        setPreview(built)
    }, [currentValues, valuesIdentifiers])

    return (
        <div className="valuer-amend-multi-select-field-container">
            <div className="valuer-amend-multi-select-label">{field}</div>
            <div className="valuer-amend-multi-select-label">
                <i>{preview}</i>
            </div>
        </div>
    )
}

export default ValuerAmendPreviewContainer
